import { ChevronDownIcon } from '@c/icons';
import {
  useClick,
  useDismiss,
  useFloating,
  useInteractions,
} from '@floating-ui/react-dom-interactions';
import {
  DropdownMenuItemType,
  NavMenuItemType,
} from '@util/hooks/useMenuItems';
import { motion } from 'framer-motion';
import Link from 'next/link';
import { useState } from 'react';

type Props = {
  label: string;
  menuItems: DropdownMenuItemType[] | NavMenuItemType[];
};

const DropdownMenu = ({ label, menuItems }: Props) => {
  const [open, setOpen] = useState(false);

  const { x, y, reference, floating, strategy, context } = useFloating({
    open,
    onOpenChange: setOpen,
    placement: 'bottom-end',
  });

  const { getReferenceProps } = useInteractions([
    useClick(context, { toggle: true }),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    useDismiss(context, { referencePointerDown: true }),
  ]);

  return (
    <>
      <button
        ref={reference}
        className="flex h-[4.4rem] cursor-pointer items-center justify-center gap-x-2 text-inherit transition-colors hover:text-brand-secondary"
        {...getReferenceProps()}
      >
        {label}
        <ChevronDownIcon />
      </button>
      {open && (
        <motion.div
          ref={floating}
          initial={{ opacity: 0, scale: 0.1 }}
          animate={{
            opacity: 1,
            scale: 1,
          }}
          transition={{ duration: 0.2 }}
          style={{
            position: strategy,
            top: y ?? 0,
            left: x ?? 0,
            width: 'max-content',
            transformOrigin: 'top right',
            zIndex: 100,
          }}
          className="flex flex-col items-start rounded-[1rem] bg-white py-[1.6rem] shadow-lg"
        >
          {menuItems.map((item) => {
            if (item.href) {
              return (
                <Link
                  key={item.label}
                  className="mx-[1.2rem] rounded-[1rem] px-[1.2rem] py-[0.8rem] text-brand-black hover:bg-brand-lighter-purple hover:text-brand-secondary"
                  href={item.href}
                >
                  {item.label}
                </Link>
              );
            } else {
              return (
                <button
                  key={item.label}
                  className="mx-[1.2rem] rounded-[1rem] px-[1.2rem] py-[0.8rem] text-left text-brand-black hover:bg-brand-lighter-purple hover:text-brand-secondary"
                  onClick={item.onClick}
                >
                  {item.label}
                </button>
              );
            }
          })}
        </motion.div>
      )}
    </>
  );
};

export default DropdownMenu;
